(() => {
  const STORAGE_KEY = 'luxRecentlyViewed';
  const MAX_STORED = 8;
  const MAX_RENDERED = 4;

  const formatMoney = (cents) => {
    const activeCurrency = window.Shopify?.currency?.active || 'USD';
    return new Intl.NumberFormat(undefined, {
      style: 'currency',
      currency: activeCurrency,
    }).format((cents || 0) / 100);
  };

  const loadHandles = () => {
    try {
      return JSON.parse(window.localStorage.getItem(STORAGE_KEY)) || [];
    } catch (_error) {
      return [];
    }
  };

  const saveHandles = (handles) => {
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(handles.slice(0, MAX_STORED)));
    } catch (_error) {
      // Ignore storage failures.
    }
  };

  const updateHistory = (currentHandle) => {
    const handles = loadHandles().filter((handle) => handle && handle !== currentHandle);
    handles.unshift(currentHandle);
    saveHandles(handles);
    return handles;
  };

  const buildCard = (product) => {
    const image = product.featured_image;
    return `
      <a class="lux-recently-viewed__card lux-reveal is-visible" href="${product.url}">
        <div class="lux-recently-viewed__image-wrap">
          ${image ? `<img class="lux-recently-viewed__image" src="${image}" alt="${product.title}" loading="lazy">` : ''}
        </div>
        <h3 class="lux-recently-viewed__title">${product.title}</h3>
        <p class="lux-recently-viewed__price">${formatMoney(product.price)}</p>
      </a>
    `;
  };

  const renderSection = async (section) => {
    const currentHandle = section.dataset.productHandle;
    if (!currentHandle) return;

    const handles = updateHistory(currentHandle)
      .filter((handle) => handle !== currentHandle)
      .slice(0, MAX_RENDERED);

    if (!handles.length) return;

    const root = window.Shopify?.routes?.root || '/';
    const requests = handles.map((handle) =>
      fetch(`${root}products/${handle}.js`)
        .then((response) => (response.ok ? response.json() : null))
        .catch(() => null)
    );

    const products = (await Promise.all(requests)).filter(Boolean);
    if (!products.length) return;

    const grid = section.querySelector('.lux-recently-viewed__grid');
    if (!grid) return;

    grid.innerHTML = products.map(buildCard).join('');
    section.hidden = false;
  };

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.js-lux-recently-viewed').forEach((section) => {
      renderSection(section);
    });
  });
})();